/* 账号冻结强制下线弹窗 */
<template>
  <div :class="$style.forceOffline">
    <header>
      <span>提示</span>
    </header>
    <main>
      <p>网络波动，请重新连接</p>
      <button class="yw-btn yw-btn-primary" @click="reload">重新登录</button>
    </main>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      skin: 'black'
    };
  },
  methods: {
    reload() {
      // 清除微信登录凭证缓存，确保重新显示登录页面
      localStorage.removeItem('wechat_login_credential');
      localStorage.removeItem('wechatAccount');
      localStorage.removeItem('isAutoLoginChecked');
      location.reload();
    }
  }
}
</script>

<style lang="scss" module>
@import "../../assets/css/common.scss";

.forceOffline {
  @include full-screen-window();
  > main {
    > button {
      @include full-screen-button();
      margin-top: 50px;
    }
    p {
      font-size: 15px;
      padding-top: 20%;
      text-align: center;
    }
  }
}
</style>